export const AUTH_CONFIG = {
  domain: 'kreature.eu.auth0.com',
  clientId: 'f9RrtmYlIu5wn4ejmN2gbZBKe1WC8pc5',
  //callbackUrl: 'http://localhost:1234/callback',
  callbackUrl: 'https://capgestion.performance-adviser.com/callback',
  //logoutUrl: 'http://localhost:1234/',
  logoutUrl: 'https://capgestion.performance-adviser.com/',
  audience: 'https://api-panneaux-app.performance-adviser.com'
}

